import { render, staticRenderFns } from "./TrialsTwo.vue?vue&type=template&id=3c6b1cc2&scoped=true&"
import script from "./TrialsTwo.vue?vue&type=script&lang=js&"
export * from "./TrialsTwo.vue?vue&type=script&lang=js&"
import style0 from "./TrialsTwo.vue?vue&type=style&index=0&id=3c6b1cc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6b1cc2",
  null
  
)

export default component.exports